module.exports = __webpack_public_path__ + "img/icon-restar.d6ac0123.svg";